import appConfig from "../../appconfig";
import {BifrostBackendApi} from "../../gateways/BifrostBackendApi";

const SubscriptionProvider = {
	async setSubscriptionProvider(idpToken, providerName, countryCode = "dk") {
		const params = {
			tenantId: appConfig.tenantId,
			countryCode,
			providerName
		};

		return BifrostBackendApi.post(
			`/subscriptions/set-provider`,
			params,
			{
				headers: {
					Authorizationidp: idpToken
				}
			})
			.then(({ data }) => data);
	},
	async subscriptionExists(idpToken) {
		const idpManagementQueryParams = {
			tenantId: appConfig.tenantConfig.tenantId
		};
		return BifrostBackendApi.get("/subscriptions/exists", {
			params: idpManagementQueryParams,
			headers: {
				Authorizationidp: idpToken
			}
		}).then(({ data }) => data);
	},
	async initializeSubscription(idpToken, countryCode, urlAccept, urlCancel, urlCheckout, planId, additionalInvoiceDetails, additionalPaymentDetails, deviceData) {
		const clientTraceIdFromStorage = localStorage.getItem("clientTraceId");
		const initializeSubscriptionBody = {
			tenantId: appConfig.tenantId,
			countryCode,
			urlAccept,
			urlCancel,
			urlCheckout,
			planId,
			additionalInvoiceDetails,
			additionalPaymentDetails,
			clientTraceId: clientTraceIdFromStorage ? clientTraceIdFromStorage : "",
			deviceData
		};

		return BifrostBackendApi.post(
			`/subscriptions/initialize`,
			initializeSubscriptionBody,
			{
				headers: {
					Authorizationidp: idpToken
				}
			})
			.then(({ data }) => data);
	},
	async initializeUpdateSubscription(idpToken, urlAccept, urlCancel, urlCheckout, planId, paymentMethod, additionalPaymentDetails) {
		const initializeUpdateSubscriptionBody = {
			tenantId: appConfig.tenantId,
			urlAccept,
			urlCancel,
			urlCheckout,
			planId,
			paymentMethod,
			additionalPaymentDetails
		};

		return BifrostBackendApi.put(
			`/subscriptions/initialize/update`,
			initializeUpdateSubscriptionBody,
			{
				headers: {
					Authorizationidp: idpToken
				}
			})
			.then(({ data }) => data);
	},
	async activateSubscriptionPlan(token, body) {
		return BifrostBackendApi.post(
			`/subscriptions/activate-plan`,
			{
				tenantId: appConfig.tenantId,
				...body
			},
			{
				headers: {
					Authorizationidp: token
				}
			})
			.then(({ data }) => data);
	},
	async updateSubscriptionPlan(token, body) {
		return BifrostBackendApi.post(
			`/subscriptions/update-plan`,
			{
				tenantId: appConfig.tenantId,
				...body
			},
			{
				headers: {
					Authorizationidp: token
				}
			})
			.then(({ data }) => data);
	},
	async listSubscriptionPlans() {
		return BifrostBackendApi.get(
			`/subscriptions/plans?tenantId=${appConfig.tenantId}`
		).then(({ data }) => data);
	},
	async listInvoicesByCustomer(token) {
		return BifrostBackendApi.get(
			`/subscriptions/invoices?tenantId=${appConfig.tenantId}`, {
				headers: {
					Authorizationidp: token
				}
			}
		).then(({ data }) => data);
	},
	async getInvoicePdfById(token, invoiceId) {
		return BifrostBackendApi.get(
			`/subscriptions/Invoices/${invoiceId}?tenantId=${appConfig.tenantId}`, {
				responseType: "blob",
				headers: {
					Authorizationidp: token
				}
			}
		).then(( response ) => {
			return {
				pdfData: response.data,
				fileName: response.headers["content-disposition"].split("filename=")[1].split(";")[0]
			};
		});
	},
	async getSubscriptionPlanById(planId) {
		return BifrostBackendApi.get(
			`/subscriptions/plans/${planId}?tenantId=${appConfig.tenantId}`
		).then(({ data }) => data);
	},
	async changeSubscriptionState(token, shopId, type) {
		return BifrostBackendApi.post(
			`/subscriptions/state?tenantId=${appConfig.tenantId}${shopId ? `&shopId=${shopId}` : ""}&type=${type}`,
			{
				tenantId: appConfig.tenantId
			},
			{
				headers: {
					Authorizationidp: token
				}
			}
		).then(({ data }) => data);
	},
	async cancelSubscription(token, shopId) {
		return BifrostBackendApi.post(
			`/subscriptions/cancel?tenantId=${appConfig.tenantId}${shopId ? `&shopId=${shopId}` : ""}`,
			{
				subscriptionConfig: {
					canceloption: 2
				}
			},
			{
				headers: {
					Authorizationidp: token
				}
			}
		).then(({ data }) => data);
	},
	async switchSubscriptionPlan(token, shopId, switchSubscriptionPlanConfig) {
		return BifrostBackendApi.post(
			`/subscriptions/switch-plan?tenantId=${appConfig.tenantId}${shopId ? `&shopId=${shopId}` : ""}`,
			{
				config: switchSubscriptionPlanConfig
			},
			{
				headers: {
					Authorizationidp: token
				}
			}
		).then(({ data }) => data);
	},
	async getPaymentMethodStatus(token, shopId) {
		return BifrostBackendApi.get(
			`/subscriptions/payment-methods`,
			{
				params: {
					tenantId: appConfig.tenantId,
					shopId
				},
				headers: {
					Authorizationidp: token
				}
			}
		).then(({ data }) => data);
	},
	async saveNetsPayment({ authorization, tenantId, customerId, planId, paymentid }) {
		if(!authorization || !tenantId || !customerId || !planId || !paymentid) {
			return;
		}

		return BifrostBackendApi.post("/subscriptions/webhooks/nets", 
			{ paymentId: paymentid },
			{
				params: {
					tenantId,
					customerId,
					planId
				}, headers: {
					authorization
				}
			}
		).then(({ data }) => data);
	}
};

export default SubscriptionProvider;
